import React from 'react';
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import Skeleton from "@material-ui/lab/Skeleton";

const LoadingBasic = () => {
    return (
        <TableRow>
            <TableCell>
                <Skeleton variant="rect" width={60} height={50} />
            </TableCell>
            <TableCell>
                <Skeleton variant="rect" width={120} height={50} />
            </TableCell>
            <TableCell>
                <Skeleton variant="rect" width={120} height={50} />
            </TableCell>
            <TableCell>
                <Skeleton variant="rect" width={120} height={50} />
            </TableCell>
            <TableCell>
                <Skeleton variant="rect" width={120} height={50} />
            </TableCell>
        </TableRow>
    );
};
export default LoadingBasic;